/**
 * @file variantDiseaseUpdate.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Oct 12, 2023 13:28
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import { stringExists } from 'src/@common/utilities';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import {
    VARIANT_DISEASE_UPDATE_REQUEST,
    variantDiseaseUpdateSuccess,
    variantDiseaseUpdateFailure,
} from 'src/store/actions/variant/variantDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/variant/variantDisease/update';
    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            variantDisease: payload.variantDisease,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* requestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (resp.payload.errorExists === true && stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalErrorMessage.options)
            );
        }

        if (resp.payload.errorExists === false && stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(variantDiseaseUpdateSuccess(resp.payload));

        if (action.payload.notify === true) {
            yield put(enqueueMessage(
                standardMessages.successfulSave.message,
                standardMessages.successfulSave.options)
            );
        }

    } catch (error) {
        yield put(variantDiseaseUpdateFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* requestMonitor() {
    yield takeLatest(VARIANT_DISEASE_UPDATE_REQUEST, requestSaga);
}
